export default __webpack_public_path__ + "static/media/winner_6.dc6bbd6d.jpg";